import StopRounded from "@mui/icons-material/StopRounded";
import { IconButton } from "@mui/material";

interface ChatInputAreaStopButtonProps {
  onClick: () => void;
}

export const ChatInputAreaStopButton = ({
  onClick,
}: ChatInputAreaStopButtonProps) => (
  <IconButton
    onClick={onClick}
    size="small"
    data-ph-capture-attribute-action="stop_ai_generation"
    data-test-id="ai-stop-button"
    sx={{
      bgcolor: "error.main",
      color: "white",
      "&:hover": {
        bgcolor: "error.main",
        opacity: 0.8,
      },
    }}
  >
    <StopRounded fontSize="small" />
  </IconButton>
);
